import { ReactNode } from 'react';

export type ButtonTypes = 'button' | 'submit' | 'reset';

export enum ButtonColorType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  GREY = 'grey',
  TEXTGREY = 'text-grey',
  WHITE = 'white',
  UNIVERSAL = 'universal'
}

export const sizes = {
  LARGE: 'large',
  REGULAR: 'regular',
  SMALL: 'small'
} as const;

export const variants = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  GREY: 'grey',
  TEXTGREY: 'text-grey',
  WHITE: 'white',
  UNIVERSAL: 'universal'
} as const;

export enum ButtonType {
  BUTTON = 'button',
  SUBMIT = 'submit',
  RESET = 'reset'
}

export type ButtonColorTypes = typeof variants[keyof typeof variants];
export type Sizes = typeof sizes[keyof typeof sizes];

export interface IBButtonProps {
  type: ButtonTypes;
  size?: Sizes;
  onClick?(e: React.MouseEvent): any;
  text: string;
  className?: string;
  disabled?: boolean;
  colorType?: ButtonColorTypes;
  pending?: boolean;
  testId?: string;
  startIcon?: ReactNode;
  endIcon?: ReactNode;
  width?: number;
  height?: number;
}

export type ButtonThemeVariant = {
  background: string;
  backgroundActive: string;
  backgroundHover: string;
  border: string | number;
  borderColorHover: string;
  boxShadow: string;
  boxShadowActive: string;
  color: string;
  colorHover: string;
  spinnerColor?: string;
  spinnerColorHover?: string;
};

export type ButtonTheme = {
  [key in ButtonColorTypes]: ButtonThemeVariant;
};
